<script>
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";

  export let event;
  export let position;
  export let jugglerNames;
  const dispatch = createEventDispatcher();

  let time;
  let juggler;
  let hand;
  let duration;
  let toJuggler;
  let toHand;

  function reload() {
    time = event.time;
    juggler = event.juggler;
    hand = event.hand + "";
    duration = event.duration;
    toJuggler = event.toJuggler;
    toHand = event.toHand + "";
  }

  $: if (event) reload();

  onMount(reload);

  function replaceNaN(value) {
    return isNaN(+value) ? undefined : +value;
  }

  function handleKeydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSave();
    } else if (event.key === 'Escape') {
      event.preventDefault();
      handleCancel();
    }
  }

  function handleSave() {
    dispatch("save", {
      ...event,
      time,
      juggler: replaceNaN(juggler),
      hand: replaceNaN(hand),
      duration,
      toJuggler: replaceNaN(toJuggler),
      toHand: replaceNaN(toHand),
    });
  }

  function handleCancel() {
    dispatch("cancel");
  }

  function handleDelete() {
    dispatch("delete", event);
  }
</script>

<div class="event-edit-box" style="position: absolute; top: {position.y}px; left: {position.x}px;">
  <label for="event-time">Time:</label>
  <input type="number" id="event-time" bind:value={time} on:keydown={handleKeydown} /><br />

  <label for="event-juggler">Juggler:</label>
  <select id="event-juggler" bind:value={juggler} on:keydown={handleKeydown}>
    {#each jugglerNames.entries() as id_name}
      <option value={id_name[0]}>
        {id_name[1]}
      </option>
    {/each}
  </select><br/>

  <label for="event-hand">Hand:</label>
  <select id="event-hand" bind:value={hand} on:keydown={handleKeydown}>
    <option value=0>Right Hand</option>
    <option value=1>Left Hand</option>
  </select><br />

  <label for="event-duration">Duration:</label>
  <input type="number" id="event-duration" bind:value={duration} on:keydown={handleKeydown} /><br />

  <label for="event-to-juggler">To Juggler:</label>
  <select id="event-t-juggler" bind:value={toJuggler} on:keydown={handleKeydown}>
    {#each jugglerNames.entries() as id_name}
      <option value={id_name[0]}>
        {id_name[1]}
      </option>
    {/each}
  </select><br/>

  <label for="event-to-hand">To Hand:</label>
  <select id="event-to-hand" bind:value={toHand} on:keydown={handleKeydown}>
    <option value=0>Right Hand</option>
    <option value=1>Left Hand</option>
  </select><br />

  <button on:click={handleSave}>Save</button>
  <button on:click={handleCancel}>Cancel</button>
  <button on:click={handleDelete}>Delete</button>
</div>

<style>
  .event-edit-box {
    font-size: 25px;
    border-radius: 10px;
    border: 4px solid black;
    padding: 10px;
    background-color: white;
    z-index: 100;
  }

  .event-edit-box label {
    display: inline-block;
    font-size: 25px;
    margin: 5px;
    width: 120px;
  }

  .event-edit-box input, .event-edit-box button, .event-edit-box select {
    font-size: 25px;
    margin: 5px;
  }

  .event-edit-box input {
    border: 1px solid #ddd;
    width: calc(100% - 180px);
  }

  .event-edit-box button {
    margin-top: 10px;
    margin-right: 10px;
  }
</style>
